import { initModules } from "../../../../magnolia-component-library/assets/js/utils";
import LazyLoader from "../../../../magnolia-component-library/assets/js/utils/lazyLoading/lazyLoader";
import LazyElements from "../../../../magnolia-component-library/assets/js/utils/lazyLoading/lazyElements";
import SmoothScroll from "../../../../magnolia-component-library/assets/js/utils/smooth-scroll";
import ScrollAnimations from "../../../../magnolia-component-library/assets/js/utils/scrollAnimations";

import Accordion from "../../../../magnolia-component-library/assets/js/modules/accordion";
import ScrollTop from "../../../../magnolia-component-library/assets/js/modules/scroll-top";
import Modal from "../../../../magnolia-component-library/assets/js/modules/modal";
import Expandable from "../../../../magnolia-component-library/assets/js/modules/expandable";
import Dropdown from "../../../../magnolia-component-library/assets/js/modules/dropdown";
import SyntaxHighlighter from "../../../../magnolia-component-library/assets/js/modules/syntaxHighlighter";
import DamVideo from "../../../../magnolia-component-library/assets/js/modules/damVideo";
import Slider from "../../../../magnolia-component-library/assets/js/modules/slider";
import EmbeddedForm from "../../../../magnolia-component-library/assets/js/modules/marketo/embeddedForms/index";

import ExtensionsListing from "./modules/extensionsListing/index";
import ScreenshotsSlider from "./modules/screenshotsSlider";

window.addEventListener("load", function() {
    ScrollAnimations();
    SmoothScroll();
    LazyLoader(".e-in", { rootMargin: "-25px", threshold: 0 }, LazyElements);

    initModules({
        Slider,
        ScrollTop,
        Expandable,
        Modal,
        ExtensionsListing,
        ScreenshotsSlider,
        SyntaxHighlighter,
        Accordion,
        Dropdown,
        DamVideo,
    });

    EmbeddedForm();
});
